export default __webpack_public_path__ + "static/media/ugo-icon.124fc34e.svg";